// Types for couple authentication system

export interface CoupleAuthData {
  id: string;
  partner1_name: string;
  partner2_name: string;
  created_at: string;
  access_token: string;
  expires_at: string;
}

export interface CreateCoupleRequest {
  partner1_name: string;
  partner2_name: string;
}

export interface CreateCoupleResponse {
  success: boolean;
  data?: CoupleAuthData;
  error?: string;
}

export interface LoginCoupleRequest {
  partner1_name: string;
  partner2_name: string;
}

export interface LoginCoupleResponse {
  success: boolean;
  data?: CoupleAuthData;
  error?: string;
}

export interface StoredCoupleAuth {
  id: string;
  partner1_name: string;
  partner2_name: string;
  access_token: string;
  expires_at: string;
  is_valid: boolean;
}

export interface AuthenticationError {
  message: string;
  code: 'INVALID_CREDENTIALS' | 'COUPLE_NOT_FOUND' | 'COUPLE_EXISTS' | 'TOKEN_EXPIRED' | 'STORAGE_ERROR' | 'NETWORK_ERROR';
}

// Helper types for partner identification
export type PartnerRole = 'partner1' | 'partner2';

export interface PartnerInfo {
  name: string;
  role: PartnerRole;
}

// Session management types
export interface CoupleSession {
  couple_id: string;
  access_token: string;
  expires_at: Date;
  partner1_name: string;
  partner2_name: string;
  created_at: Date;
}

// Storage keys for localStorage
export const STORAGE_KEYS = {
  COUPLE_AUTH: 'couple_auth_data',
  LAST_LOGIN: 'couple_last_login',
  SESSION_EXPIRY: 'couple_session_expiry'
} as const;

// Token configuration
export const TOKEN_CONFIG = {
  EXPIRY_HOURS: 24 * 7, // 7 days
  REFRESH_THRESHOLD_HOURS: 2 // Refresh token if expiring within 2 hours
} as const;